import axios from "axios";

const RESPONSE_CODES = {
  ok: 200,
  not_found: 404
};

export class PinchMeAPI {
  constructor(baseURL) {
    this.baseURL = baseURL;

    this.defaultHeaders = {
      "Content-Type": "application/json"
    };
  }

  // Sign up
  submitSignup = (
    firstName,
    lastName,
    email,
    password,
    birthdate,
    zipCode,
    gender
  ) => {
    return this.execute(
      "post",
      "/api/v1/signup",
      {},
      {},
      {
        user: {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          user_profile_attributes: {
            birthdate: birthdate,
            zip_code: zipCode,
            gender: gender
          }
        }
      }
    );
  };

  getTestinonials = () => {
    return this.execute("get", "/testimonials_for_signup.json");
  };

  // Login
  submitLogin = (email, password) => {
    return this.execute(
      "post",
      "/api/v1/login",
      {},
      {},
      {
        user: {
          email: email,
          password: password
        }
      }
    );
  };

  submitInquiry = (company, name, email, note) => {
    return this.execute(
      "post",
      "/api/v1/inquiries",
      {},
      {},
      {
        inquiry: {
          company: company,
          name: name,
          email: email,
          note: note
        }
      }
    );
  };

  submitCaptchaValidator = response => {
    return this.execute(
      "post",
      "api/v1/validate_captcha",
      {},
      {},
      {
        captcha: {
          response: response
        }
      }
    );
  };

  //Wallet Campaigns
  getCampaigns = () => {
    return this.execute("get", "/campaigns.json");
  };

  getClaimedCampaigns = () => {
    return this.execute("get", "/campaigns/claimed");
  };

  //Wallet Trials
  getUserTrials = () => {
    return this.execute("get", "/wallet/user_trials");
  };

  getCompletedUserTrials = () => {
    return this.execute("get", "/wallet/completed_user_trials");
  };

  getTrialTags = trial_id => {
    return this.execute("get", `/wallet/trial_tags/${trial_id}`);
  };

  //QWIZme Checkout
  getPrizeTiers = () => {
    return this.execute("get", "/qwizme/prizes");
  };

  getUserInfo = () => {
    return this.execute("get", "/user/info");
  };

  getUserCoins = () => {
    return this.execute("get", "/user/coins");
  };

  getUserAddress = () => {
    return this.execute("get", "/user/address");
  };

  submitUserAddress = address => {
    return this.execute("post", "/user/address", {}, {}, { address: address });
  };

  submitQwizmeCheckout = prizeTierId => {
    return this.execute(
      "post",
      "/qwizme/checkout",
      {},
      {},
      { prize_tier_id: prizeTierId }
    );
  };

  getQwizmeOrders = () => {
    return this.execute("get", "/qwizme/orders");
  };

  getUser = () => {
    return this.execute("get", "/qwizme_get_user");
  };

  getWeeklyResult = () => {
    return this.execute("get", "/qwizme/weekly_result");
  };

  getMonthlyResult = () => {
    return this.execute("get", "/qwizme/monthly_result");
  };

  getPastWinners = () => {
    return this.execute("get", "/qwizme/past_winners");
  };

  getSurveys = () => {
    return this.execute("get", "/qwizme/surveys");
  };

  getUserCartItems = () => {
    return this.execute("get", "/cart");
  };

  getRecentSamples = () => {
    return this.execute("get", "/recent_samples");
  };

  addUserCartItem = (campaign_id, promo_offering_id) => {
    return this.execute(
      "post",
      "/wallet/cart/add_item",
      {},
      {},
      {
        campaign_id: campaign_id,
        promo_offering_id: promo_offering_id
      }
    );
  };

  removeUserCartItem = (campaign_id, promo_offering_id) => {
    return this.execute(
      "post",
      "/wallet/cart/remove_item",
      {},
      {},
      {
        campaign_id: campaign_id,
        promo_offering_id: promo_offering_id
      }
    );
  };

  getUserIncentives = () => {
    return this.execute("get", "/incentives");
  };

  getUserIncentives = () => {
    return this.execute("get", "/incentives");
  };

  getUserRewards = () => {
    return this.execute("get", "/rewards_for_user");
  };

  getSampleTuesdayDate = () => {
    return this.execute("get", "/api/v1/landing/sample_tuesday");
  };

  combineHeaders = headers => {
    return { ...this.defaultHeaders, ...headers };
  };

  getQueryParams = () => {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    let hash = {};
    vars.forEach(obj => {
      let pair = obj.split("=");
      if (pair[0] !== undefined && pair[0].length !== 0) {
        hash[decodeURIComponent(pair[0].toString())] = decodeURIComponent(
          pair[1]
        );
      }
    });

    return hash;
  };

  getQueryParam = variable => {
    const params = this.getQueryParams();
    let result = null;

    if (params[variable] !== undefined) {
      result = params[variable];
    }

    return result;
  };

  queryString = urlParams => {
    return Object.keys(urlParams)
      .map(k => k + "=" + urlParams[k])
      .join("&");
  };

  getCSRFToken = () => {
    return document.querySelector("[name=csrf-token]").content;
  };

  execute = (method, endpoint, urlParams = {}, headers = {}, data = {}) => {
    const queryString = this.queryString(urlParams);
    const url = endpoint + "?" + queryString;

    let token_headers = { "X-CSRF-Token": this.getCSRFToken() };
    let all_headers = this.combineHeaders({ ...headers, ...token_headers });

    return axios(url, {
      method,
      baseURL: this.baseURL,
      headers: all_headers,
      data
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error.response;
      });
  };
}

const api = new PinchMeAPI(process.env.PINCHME_URL);

export default api;
